<template>
	<div class="ticket-autocp">
		<div class="close-layer" v-if="Str&&isSearch" @click="isSearch=false"></div>
		<div :class="Str&&isSearch?'search-bar-a active':'search-bar-a'">
            <div class="search-filter">
                <div class="city-box">
                    <input type="text" placeholder="请输入目的地、主题或景区名" v-model="Str" @focus="isSearch=true"/>
                </div>
            </div>
            <div class="search-btn"  @click="search()">搜索</div>
            <div class="tka-box" v-if="Str&&isSearch">
				<div class="tkab-list" v-if="!isLoading">
					<ul>
						<li v-for="item in list" @click="toDetails(item)">
							<span>{{item.ScenicName}}</span>
						</li>
					</ul>
				</div>
				<div class="table-loading" v-else >
		            <Loading :isLoading="isLoading"></Loading>
		        </div>
		        <div class="table-loading" v-if="!isLoading&&(!list||list.length<1)" >
		        	没有相关门票...
		        </div>
			</div>
       	</div>

	</div>
</template>
<script>
    import Loading from './../../../common/cmpnt/Loading/Loading.vue'//缓冲
	export default{
		name:"ticket-auto-complete",
		components:{
			Loading
		},
		props:{
			param:{
				type:String,
				default:''
			}
		},
		watch:{
			Str(){
				
				this.initData();
			}
		},
		data(){
			return{
				Str:'',
				isSearch:false,
				list:'',
				isLoading:false
			}
		},
		methods:{
			close(){

			},
			search () {
				this.isSearch=false;
				this.$emit('search',this.Str)
                
            },
			toDetails (item) {
                window.open( '#/ticketDetails?id='+item.ScenicId, '_blank');
				
            },
			initData(city,index) {
                var that = this;
                that.isLoading=true;
                var params = {
                    Str: that.Str,
                    TicketType: '',
                    Level: '',
                    Page: 1,
                    PageSize: 10,
                    MyCity: city||'',
                    Radius: '',
                    MyLat: '',
                    MyLon: '',
                }
                that.postRequest({
                    url:that.Api.getTicketList,
                    params: params
                }).then(res => {
                    that.isLoading=false;
                    if (res && res.IsSuccess) {
                        that.list=res.Result;
                    } else {
                        // $state.complete();
                    }
                });
        
            }

		},
		mounted(){
			this.Str=this.param;
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/ticket/autoComplete/autoComplete.vue